import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import(/* webpackChunkName: "searchClients" */ './index'),
  loading: () => null,
});
